import { IntegrationAuthRedirect } from '../components/IntegrationAuthRedirect/IntegrationAuthRedirect';

export const SlackAuth = () => <IntegrationAuthRedirect type="slack" />;
